import React, { useState, useEffect } from "react";
import { httpPost } from "../../../utility/requestHelper";
import { envConfig, unifiedEnvConfig } from "../../../constants/api-endpoint";
import {
  TonalityTag,
  CategoryTag,
  FavouriteTag,
} from "../../Shared/Tags/index";
import { useSelector } from "react-redux";
import {
  THEME_LABEL,
  TONE_LABEL,
  UNSET_THEME_LABEL,
  UNSET_TONE_LABEL,
  CONSTANTS,
  COOKIE,
  VERTICALS,
} from "../../../constants/app-constant";
import Loader from "rsuite/Loader";
import { groupBy } from "../../../utility/common-methods";
import PrintAndOnlineNews from "./PrintAndOnline";
import { SOCIAL_TONALITY_FILTER } from "../../../constants/static-filter";
import { getCookie } from "../../../utility/cookieProvider";
import TicketPopup from "../../Shared/TicketPopup";
import { FEED_DETAILS } from "../../../constants/route-constants";

function ArticleTags({
  article = {},
  mediaType,
  newsDetails,
  singleNewsGroup,
  onSuccessCallback,
  hideTheme,
  isSocial,
  isBlogAndForum,
  callSocialAPI,
  showFavouriteTag,
  updatedBulkTheme,
  updatedBulkSentiment,
  updatedBulkFavourite,
  isSingleFeedSelected,
  forBulkUpdate,
  setUpdatedBulkSentiment,
  setUpdatedBulkTheme,
  hideTonality,
  getFeedSearchUrl,
  isPrintAndOnline,
  isTV = false,
  isOnline = false,
  isPrint = false,
  entityName,
  showTicket
}) {
  const {
    categories,
    tonalities,
    client_detail,
    updated_values,
    entity_detail,
    Forclient_id,
    is_client_favourite,
    category
  } = article;
  const updatedArticle =
  updated_values && updated_values[0] ? updated_values[0] : article;
  const updatedFav = updatedArticle.is_client_favourite;
  const [selectedTonality, setSelectedTonality] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedFavourite, setSelectedFavourite] = useState(false);
  const [sentimentsLoader, setSentimentsLoader] = useState(false);
  const [categoryLoader, setCategoryLoader] = useState(false);
  const [favouriteLoader, setFavouriteLoader] = useState(false);
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);
  const email = getCookie(COOKIE.CONCEPT_USER_EMAIL);


  const clientReducer = useSelector((state) => state.clientReducer) || {};
  const { selectedClient = {}, clientTagData = {} , masterUser = {}  } = clientReducer || {};
  const clientId =
    (client_detail && client_detail.id) || Forclient_id || selectedClient.id;
  const entityId = entity_detail && entity_detail.id;
  const { allow_tag } = client_detail || {};
  let tonalityList =
    (clientTagData &&
      clientTagData.tonality &&
      Object.keys(clientTagData.tonality)) ||
    [];
  if (callSocialAPI || isBlogAndForum || isSocial) {
    tonalityList = SOCIAL_TONALITY_FILTER.values.map((t) => t.value);
  }
  let categoryList =
    (clientTagData &&
      clientTagData.categories &&
      clientTagData.categories.data) ||
    [];
  if (newsDetails && !isSocial && !isBlogAndForum) {
    tonalityList = tonalities && Object.keys(tonalities);
    categoryList = categories;
  }

  const containsBulkUpdatedData =
    forBulkUpdate && (updatedBulkTheme || updatedBulkSentiment);
  // updatedArticle.tonality = !updatedArticle.tonality ? "" : updatedArticle.tonality;
  // updatedArticle.category = !updatedArticle.category
  //   ? ""
  //   : updatedArticle.category;
  const isTagsChanged =
    updatedArticle.tonality != selectedTonality ||
    updatedArticle.category != selectedCategory;
  const isValidTag =
    selectedCategory ||
    selectedTonality ||
    selectedFavourite == false ||
    selectedFavourite == true;
  const articleTonality =
    updatedArticle &&
    updatedArticle.social_feed_tonality &&
    updatedArticle.social_feed_tonality.tonality;
  useEffect(() => {
    if (articleTonality || updatedArticle.tonality) {
      setSelectedTonality(articleTonality || updatedArticle.tonality);
    }
    if (updatedArticle.category) {
      setSelectedCategory(updatedArticle.category);
    }
    let updatedFavourites = {};
    if (showFavouriteTag && !forBulkUpdate) {
      updatedFavourites = article.favourites || {};
      setSelectedFavourite(
        updatedFavourites && updatedFavourites.is_favourite
          ? updatedFavourites.is_favourite
          : false
      );
    }

    if (showFavouriteTag && forBulkUpdate) {
      if (article && article.length) {
        const isAnyFavouriteFalse = article.some((i) => {
          return i.favourites && !i.favourites.is_favourite;
        });
        const isAnyFavouriteTrue = article.filter((i) => {
          return i.favourites && i.favourites.is_favourite;
        });
        if (isAnyFavouriteTrue && isAnyFavouriteTrue.length == article.length) {
          setSelectedFavourite(true);
        } else {
          setSelectedFavourite(false);
        }
      } else {
        setSelectedFavourite(true);
      }
    }
  }, [updatedArticle]);

  useEffect(() => {
    let mounted = true;
    const shouldFetchTags =
      !callSocialAPI && isTagsChanged && !containsBulkUpdatedData && isValidTag;
    if (shouldFetchTags && !isSocial && !isBlogAndForum) {
      const paylaod =  formatTagData();
      if (selectedTonality || selectedCategory) {
        setSentimentsLoader(selectedTonality ? true : false);
        setCategoryLoader(selectedCategory ? true : false);
        httpPost(`${isTV ? envConfig.SET_ARTICLE_TAG_FOR_TV: envConfig.SET_ARTICLE_TAG}`, paylaod)
          .then((res) => {
            setSentimentsLoader(false);
            setCategoryLoader(false);
            if (forBulkUpdate) {
              onSuccessCallback(selectedTonality, selectedCategory);
              setSelectedTonality("");
              setSelectedCategory("");
            } else {
              onSuccessCallback();
            }
          })
          .catch((e) => {
            console.log("Error in updating tags", e);
            setSentimentsLoader(false);
            setCategoryLoader(false);
          });
      }
    }
    if (
      shouldFetchTags &&
      isSocial &&
      forBulkUpdate &&
      selectedTonality &&
      mounted
    ) {
      const entityIdList = [...new Set(article.map((i) => i.entityId))];
      sentimentsBulkUpdateForSocial(entityIdList);
    }
    if (
      shouldFetchTags &&
      !isSocial &&
      isBlogAndForum &&
      forBulkUpdate &&
      selectedTonality &&
      mounted
    ) {
      sentimentsBulkUpdateForBlogAndForum();
    }
    return () => {
      mounted = false;
    };
  }, [selectedTonality, selectedCategory]);

  useEffect(() => {
    if (!newsDetails && isSingleFeedSelected) {
      updatedBulkTheme && setSelectedCategory(updatedBulkTheme);
      updatedBulkSentiment && setSelectedTonality(updatedBulkSentiment);
      setSelectedFavourite(updatedBulkFavourite);
    }
  }, [updatedBulkSentiment, updatedBulkTheme]);

  useEffect(() => {
    if (
      !newsDetails &&
      isSingleFeedSelected &&
      typeof updatedBulkFavourite == "boolean"
    ) {
      setSelectedFavourite(updatedBulkFavourite);
      Array.isArray(article)
        ? article.map(
            (feed) => (feed.is_client_favourite = updatedBulkFavourite ? 1 : "")
          )
        : (article.is_client_favourite = updatedBulkFavourite ? 1 : "");
    }
  }, [updatedBulkFavourite]);

  useEffect(() => {
    setInitialFavourite();
  }, [article]);

  useEffect(() => {
    return () => {
      if (forBulkUpdate) {
        setUpdatedBulkSentiment && setUpdatedBulkSentiment("");
        setUpdatedBulkTheme && setUpdatedBulkTheme("");
        setSelectedFavourite(false);
      }
    };
  }, []);

  const setInitialFavourite = () => {
    if (isPrintAndOnline || isTV) {
      if (!forBulkUpdate) {
        const updatedFav = updatedArticle.is_client_favourite;
        const isFav =
          is_client_favourite == 1 ? true : updatedFav == 1 ? true : false;
        setSelectedFavourite(isFav);
      } else {
        setSelectedFavourite(checkBulkFavourite());
      }
    }
  };
  const checkBulkFavourite = () => {
    const data = singleNewsGroup.filter(
      (feed) => feed.is_client_favourite == ""
    );
    return !data.length;
  };

  const formatFeedsForSentimentBulkUpdate = (array) => {
    const listGroupedByEntities = groupBy(array, "entityId");
    let formattedList = [];
    for (const entityKey in listGroupedByEntities) {
      if (Object.hasOwnProperty.call(listGroupedByEntities, entityKey)) {
        const listByEntity = listGroupedByEntities[entityKey];
        const groupedByType = groupBy(listByEntity, "type");
        for (const typeKey in groupedByType) {
          if (Object.hasOwnProperty.call(groupedByType, typeKey)) {
            const listByType = groupedByType[typeKey];
            formattedList.push({
              type: typeKey,
              entity: entityKey,
              feeds: listByType,
            });
          }
        }
      }
    }
    return formattedList;
  };

  const formatBlogAndForumSentimentsData = (list) => {
    let feedsList = [];
    let updateByFilter = false;
    list.forEach((item) => {
      if (item.isBulkUpdate) {
        updateByFilter = item.isBulkUpdate;
      }
      feedsList.push(item.public_id);
    });
    return {
      updateByFilter,
      tonality: selectedTonality,
      feeds: feedsList,
    };
  };

  const sentimentsBulkUpdateForBlogAndForum = (feedIndex = 0) => {
    const formattedList = formatFeedsForSentimentBulkUpdate(article);
    let promiseList = [];
    formattedList.forEach((item) => {
      const payload = formatBlogAndForumSentimentsData(item.feeds);
      const currentEntity = [item.entity];
      const currentverticalType = item.type;
      promiseList = [
        ...promiseList,
        httpPost(
          getFeedSearchUrl(currentEntity, currentverticalType, "sentiment"),
          payload
        ),
      ];
    });

    setSentimentsLoader(true);
    Promise.allSettled(promiseList)
      .then(() => {
        setSentimentsLoader(false);
        if (forBulkUpdate) {
          onSuccessCallback(selectedTonality, selectedCategory);
          setSelectedTonality("");
          setSelectedCategory("");
        } else {
          onSuccessCallback();
        }
      })
      .catch((e) => {
        setSentimentsLoader(false);
        console.log("Error in updating tags", e);
      });
  };

  const formatSocialSentimentsData = (entityId) => {
    let feedsList = [];
    let updateByFilter = false;
    article.forEach((item) => {
      if (entityId == item.entityId) {
        if (item.isBulkUpdate) {
          updateByFilter = item.isBulkUpdate;
        }
        feedsList.push(item.public_id);
      }
    });
    return {
      updateByFilter,
      tonality: selectedTonality,
      feeds: feedsList,
    };
  };

  const sentimentsBulkUpdateForSocial = (entityIdList) => {
    let promiseList = [];
    entityIdList.forEach((entity) => {
      const payload = formatSocialSentimentsData(entity);
      const currentEntity = [entity];
      promiseList = [
        ...promiseList,
        httpPost(getFeedSearchUrl(currentEntity, "sentiment"), payload),
      ];
    });

    setSentimentsLoader(true);
    Promise.allSettled(promiseList)
      .then(() => {
        setSentimentsLoader(false);
        if (forBulkUpdate) {
          onSuccessCallback(selectedTonality, selectedCategory);
          setSelectedTonality("");
          setSelectedCategory("");
        } else {
          onSuccessCallback();
        }
      })
      .catch((e) => {
        setSentimentsLoader(false);
        console.log("Error in updating tags", e);
      });
  };

  const setSentimentData = (tonality) => {
    setSelectedTonality(tonality);
    if (callSocialAPI) {
      httpPost(
        `${unifiedEnvConfig.SOCIAL_UPDATE_SENTIMENTS}?client_id=${clientId}`,
        {
          tonality,
          updateByFilter: false,
          feeds: [article.public_id],
        }
      )
        .then((res) => {
          onSuccessCallback();
        })
        .catch((e) => {
          console.log("Error in updating tags", e);
        });
    }
  };

  const formatFavouritesData = (entityId, favouriteFlag) => {
    let feedsList = [];
    let updateByFilter = false;
    article.forEach((item) => {
      if (entityId == item.entityId) {
        if (item.isBulkUpdate) {
          updateByFilter = item.isBulkUpdate;
        }
        feedsList.push({
          social_feed_id: item.id,
          channel_type: item.channel_type,
        });
      }
    });
    return {
      updateByFilter,
      is_favourite: favouriteFlag,
      feeds: feedsList,
    };
  };

  const formatBlogAndForumFavouritesData = (list, favouriteFlag) => {
    let feedsList = [];
    let updateByFilter = false;
    list.forEach((item) => {
      if (item.isBulkUpdate) {
        updateByFilter = item.isBulkUpdate;
      }
      feedsList.push({
        social_feed_id: item.id,
        channel_type: item.channel_type,
      });
    });
    return {
      updateByFilter,
      is_favourite: favouriteFlag,
      feeds: feedsList,
    };
  };

  const setFavouriteData = (favouriteFlag) => {
    setSelectedFavourite(favouriteFlag);
    const formatBulkFav = ()=>{
      const {client_id, category_id, electronic_client_detail_id, electronic_id, entity_id, is_client_favourite} = article

      let _category = categoryList.filter(
        (c) => c.category_name == selectedCategory
      )[0];
      if(article && article.length){
        return{
          articles : 
        article.map((i)=>{
          const {client_id, category_id, electronic_client_detail_id, electronic_id, entity_id, is_client_favourite} = i
          return{
            client_id,
            tonality: selectedTonality,
            category_id: selectedCategory == UNSET_THEME_LABEL
            ? "-1"
            : _category && _category.id,
            electronic_id ,
            electronic_client_detail_id,
            user_id : concept_uid,
            email:email,
            entity_id,
            is_client_favourite: favouriteFlag?1:-1
          }
        })}
      }
      else{
        return{
          articles : [{
            client_id,
            tonality: selectedTonality,
            category_id: selectedCategory == UNSET_THEME_LABEL
          ? "-1"
          : _category && _category.id,
          electronic_id ,
          electronic_client_detail_id,
          user_id : concept_uid,
          email:email,
          entity_id,
          is_client_favourite: favouriteFlag?1:-1
        }]
        }
      }
    }
    if (!isPrintAndOnline) {
      if (showFavouriteTag && !forBulkUpdate) {
        httpPost(
          `${unifiedEnvConfig.UPDATE_FAVOURITES_TAG}?client_id=${clientId}`,
          {
            updateByFilter: false,
            is_favourite: favouriteFlag,
            feeds: [
              {
                social_feed_id: article.id,
                channel_type: article.channel_type,
              },
            ],
          }
        )
          .then((res) => {
            onSuccessCallback();
          })
          .catch((e) => {
            console.log("Error in updating tags", e);
          });
      }
      if (showFavouriteTag && forBulkUpdate && !isBlogAndForum) {
        if(isTV){
          const entityIdList = [...new Set(article.map((i) => i.entityId))];
          let promiseList = [];
          entityIdList.forEach((entity) => {
            const payload =  formatBulkFav();
            const currentEntity = [entity];
            promiseList = [
              ...promiseList,
              httpPost(envConfig.SET_ARTICLE_TAG_FOR_TV, payload),
            ];
          });
          setFavouriteLoader(true);
          Promise.allSettled(promiseList)
            .then((res) => {
              // setting all selected feeds favourite values.
              article.forEach((item) => {
                if (item && item.favourites) {
                  item.favourites.is_favourite = favouriteFlag;
                }
              });
              onSuccessCallback("", "",favouriteFlag);
              setFavouriteLoader(false);
            })
            .catch((e) => {
              setFavouriteLoader(false);
              console.log("Error in updating tags", e);
            })

        }else{
        const entityIdList = [...new Set(article.map((i) => i.entityId))];
        let promiseList = [];
        entityIdList.forEach((entity) => {
          const payload = formatFavouritesData(entity, favouriteFlag) ;
          const currentEntity = [entity];
          promiseList = [
            ...promiseList,
            httpPost(getFeedSearchUrl(currentEntity, "favourite"), payload),
          ];
        });
        setFavouriteLoader(true);
        Promise.allSettled(promiseList)
          .then((res) => {
            // setting all selected feeds favourite values.
            article.forEach((item) => {
              if (item && item.favourites) {
                item.favourites.is_favourite = favouriteFlag;
              }
            });
            onSuccessCallback("", favouriteFlag);
            setFavouriteLoader(false);
          })
          .catch((e) => {
            setFavouriteLoader(false);
            console.log("Error in updating tags", e);
          });}
      }
      if (showFavouriteTag && forBulkUpdate && isBlogAndForum) {
        const formattedList = formatFeedsForSentimentBulkUpdate(article);
        let favouritePromiseList = [];
        formattedList.forEach((item) => {
          const payload = formatBlogAndForumFavouritesData(
            item.feeds,
            favouriteFlag
          );
          const currentEntity = [item.entity];
          const currentverticalType = item.type;
          favouritePromiseList = [
            ...favouritePromiseList,
            httpPost(
              getFeedSearchUrl(currentEntity, currentverticalType, "favourite"),
              payload
            ),
          ];
        });
        setFavouriteLoader(true);
        Promise.allSettled(favouritePromiseList)
          .then((res) => {
            // setting all selected feeds favourite values.
            article.forEach((item) => {
              if (item && item.favourites) {
                item.favourites.is_favourite = favouriteFlag;
              }
            });
            onSuccessCallback("", "", favouriteFlag);
            setSelectedFavourite(favouriteFlag);
            setFavouriteLoader(false);
          })
          .catch((e) => {
            setFavouriteLoader(false);
            console.log("Error in updating tags", e);
          });
      }
    }
    if (isPrintAndOnline) {
      if (showFavouriteTag) {
        const paylaod = formatTagData();
        setFavouriteLoader(true);
       if(!isTV) {
         httpPost(`${envConfig.SET_ARTICLE_TAG}`, {
          ...paylaod,
          tagged_data: {
            is_client_favourite: favouriteFlag ? 1 : -1,
          },
        })
          .then((res) => {
            if (forBulkUpdate) {
              onSuccessCallback("", "", favouriteFlag);
              setSelectedFavourite(favouriteFlag);
            }
            setFavouriteLoader(false);
          })
          .catch((e) => {
            console.log("Error in updating tags", e);
            setFavouriteLoader(false);
          });
      }else{
        httpPost(`${envConfig.SET_ARTICLE_TAG_FOR_TV }`, 
         formatBulkFav()
        )
          .then((res) => {
            if (forBulkUpdate) {
              onSuccessCallback("", "", favouriteFlag);
              setSelectedFavourite(favouriteFlag);
            }
            setFavouriteLoader(false);
          })
          .catch((e) => {
            console.log("Error in updating tags", e);
            setFavouriteLoader(false);
          });
      }
    
    }
    }
  };

  let formatTagData = () => {
    if (newsDetails) {
      const { id, publish_datetime } = article; //article_id, publish_date
      let _category = categoryList.filter(
        (c) => c.category_name == selectedCategory
      )[0];
      return {
        client_id: clientId,
        tagged_data: {
          tonality:
            selectedTonality == UNSET_TONE_LABEL ? "-1" : selectedTonality,
          category:
            selectedCategory == UNSET_THEME_LABEL
              ? "-1"
              : _category
              ? {
                  id: _category.id,
                  name: _category.category_name,
                }
              : {},
        },
        other_tagged_data: [],
        article_data: [
          {
            entity_id: entityId,
            article_id: +id,
            media_type: mediaType,
            pub_date: publish_datetime.toString().split(" ")[0],
            entity_articles_id: "",
          },
        ],
      };
    } else if(isTV){
      let _category = categoryList.filter(
        (c) => c.category_name == selectedCategory
      )[0];
        if(article && article.length){
          return{
            articles : 
          article.map((i)=>{
            const {client_id, category_id, electronic_client_detail_id, electronic_id, entity_id, is_client_favourite} = i
            return{
              client_id,
              tonality: selectedTonality,
              category_id: selectedCategory == UNSET_THEME_LABEL
              ? "-1"
              : _category && _category.id,
              electronic_id ,
              electronic_client_detail_id,
              user_id : concept_uid,
              email:email,
              entity_id,
            }
            
          })
        }
      }
      else{
        const {client_id, category_id, electronic_client_detail_id, electronic_id, entity_id, is_client_favourite} = article
        return{
          articles : [{

            client_id,
            tonality: selectedTonality,
            category_id: selectedCategory == UNSET_THEME_LABEL
            ? "-1"
            : _category && _category.id,
            electronic_id ,
            electronic_client_detail_id,
            user_id : concept_uid,
            email:email,
            entity_id,
          }]
          }
      }
    }
    else{
      let _category =
        categoryList &&
        categoryList.filter((c) => c.category_name == selectedCategory)[0];
      return {
        client_id: clientId,
        tagged_data: {
          tonality:
            selectedTonality == UNSET_TONE_LABEL ? "-1" : selectedTonality,
          category:
            selectedCategory == UNSET_THEME_LABEL
              ? "-1"
              : _category
              ? {
                  id: _category.id,
                  name: _category.category_name,
                }
              : {},
        },
        other_tagged_data: [],
        article_data:
          singleNewsGroup &&
          singleNewsGroup.map((singleFeed) => {
            const { article_id, entity_id, article_type, publish_date } =
              singleFeed;
            return {
              entity_id,
              article_id,
              media_type: !isTV ? article_type.toLowerCase() : "",
              pub_date: publish_date,
              entity_articles_id: "",
            };
          }),
      };
    }
  };

  const showTagging = () => {
    if (!isSocial && !isBlogAndForum) {
      return newsDetails ? allow_tag == 1 : selectedClient.allow_tag == 1;
    }

    return article;
  };
  const isDisabled = !showTagging();
  return (
    <>
      {showTicket == true && (Object.keys(masterUser).length && (isSocial || isPrint || isOnline || isTV))?
        <TicketPopup 
          detail={Object.keys(article).length?{
            media_type : (isOnline?1:(isPrint?2:isSocial?4:VERTICALS.V_TV)),
            article_id : isSocial?article.id:(isTV?article.program_id:article.article_id),
            heading : isSocial?article.message.substr(0,100):(isTV?article.headline:article.headline),
            entity : isSocial?entityName:(isTV?article.entity_name:article.entity_display_name),
            article_url : isSocial?`https://${window.location.host}${FEED_DETAILS}/sad/${clientId}-${article.channel_type}/${article.id}?entityName="${entityName}"`:(isTV?article.video_link:article.link),
          }:{}} 
        />
      :""}
      {!hideTheme &&(
        <>
          {categoryLoader ? (
            <Loader />
          ) : (
            <li className="themeLi tlCategory">
              <CategoryTag
                label={THEME_LABEL}
                defaultValue={selectedCategory}
                onSelect={setSelectedCategory}
                options={categoryList}
                optionsFor="category"
                newsDetails={newsDetails}
                hideUnsetOption={!isPrintAndOnline}
                isPrintAndOnline={isPrintAndOnline}
                forBulkUpdate={forBulkUpdate}
                isDisabled={isDisabled}
              />
            </li>
          )}
        </>
      )}
      {!hideTonality &&  (
        <>
          {sentimentsLoader ? (
            <Loader />
          ) : (
            <li className="themeLi tlTonality">
              <TonalityTag
                label={TONE_LABEL}
                defaultValue={selectedTonality}
                onSelect={setSentimentData}
                options={tonalityList}
                optionsFor="tonality"
                newsDetails={newsDetails}
                hideUnsetOption={!isPrintAndOnline}
                isSocial={isSocial}
                isBlogAndForum={isBlogAndForum}
                forBulkUpdate={forBulkUpdate}
                isPrintAndOnline={isPrintAndOnline}
                isDisabled={isDisabled}
              />
            </li>
          )}
        </>
      )}
      {showFavouriteTag && (
        <>
          {favouriteLoader ? (
            <Loader />
          ) : (
            <li className="themeLi tlFavourite">
              <FavouriteTag
                defaultValue={selectedFavourite}
                onFavouriteIconClick={setFavouriteData}
              />
            </li>
          )}
        </>
      )}
    </>
  );
}

export default ArticleTags;

ArticleTags.defaultProps = {
  onSuccessCallback: () => {},
};
